import { translate, showMessageToastCustom, getUrlConfigApi, getApiKeyLogistics } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as logisticsResourcesActions from '../actions/logisticsResourcesAction';
import * as configAction from '../actions/configAction';
import HttpService from './HttpService';


const httpService = new HttpService(getUrlConfigApi(window), getApiKeyLogistics(window));
export default class ConfigurationService {
    static getConfigs = (filter, callback) => {
        const url = '/config';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        callback(response.data.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static putConfig = (vision, data, callback) => {
        const url = '/config';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            // atualizar o reducer config
                            callback();
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getResourcesAll = () => {
        const url = '/resource/all';
        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(logisticsResourcesActions.setResources(response.data.data.items));
                    }
                }).catch((error) => {
                    console.log(error)
                });
            }
        };
    }

    static getResources = (vision, filter) => {
        const url = '/resource/all';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(configAction.setResources(response.data.data));
                        dispatch(logisticsResourcesActions.setResources(response.data.data.items));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PostResources = (vision, resource, callback) => {
        const url = '/resource';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, resource, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutResources = (vision, resource, callback) => {
        const url = '/resource';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, resource, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteResource = (resourceId, callback) => {
        const url = '/resource';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${resourceId}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.data?.success) {
                        showMessageToastCustom(translate('sucess-to-delete', 'general'), response?.data?.message, 3000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) callback(response.data?.data)
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteSelected(ids, callback) {
        if (navigator.onLine) {
            const url = `/resource/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getPrints(vision, filter) {
        const url = '/printer';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(configAction.setPrints(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PostPrint = (print, callback) => {
        const url = '/printer';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, print, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutPrint = (print, callback) => {
        const url = '/printer';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, print, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteSelectedPrinter(ids, callback) {
        if (navigator.onLine) {
            const url = `/printer/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static TestePrintServer = (ipAddress, port, ZPLString, callback) => {
        let url = `/printer/zebra/teste?&ipAddress=${ipAddress}&port=${port}`;
        if (ZPLString && ZPLString !== '') {
            url = `${url}&ZPLString=${ZPLString}`;
        }

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.patch(url, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getEquipments(vision, filter) {
        const url = '/equipment';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(configAction.setEquipments(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PostEquipment = (equipment, callback) => {
        const url = '/equipment';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(
                    url,
                    equipment,
                    { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }
                ).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutEquipment = (equipment, callback) => {
        const url = '/equipment';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, equipment, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deletePrint = (printerId, callback) => {
        const url = '/printer';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${printerId}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.data?.success) {
                        showMessageToastCustom(translate('sucess-to-delete', 'general'), response?.data?.message, 3000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) callback(response.data?.data)
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static DeleteEquipment = (equipmentId, callback) => {
        const url = '/equipment';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${equipmentId}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getEquipmentTypes(vision, filter) {
        const url = '/equipmenttype';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(configAction.setEquipmentTypes(response.data.items));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getToken = (filter) => {
        const url = 'config/tokens';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(configAction.setTokens(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static addToken = (token, callback) => {
        const url = 'config/token';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, token, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    static deleteToken = (id, callback) => {
        const url = 'config/token';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${id}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback({ message: "Item excluido com sucesso" });
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    //#region  Alertas Email 

    static getAlertEmail = (filter) => {
        const url = 'alertemail/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(configAction.setAlertsPaged(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static insertAlertEmail = (email, callback) => {
        const url = 'alertemail';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, { email }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    static deleteAlertEmail = (id, callback) => {
        const url = 'alertemail';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${id}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback({ message: "Item excluido com sucesso" });
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }
    //#endregion

    static live(callback) {
        const url = '/live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }

    static clearConfigurations() {
        return (dispatch) => {
            dispatch(configAction.reset());
        };
    }
}
